import { useMemo } from 'react';
import { useRouter } from 'next/navigation';

//* HOO'C
import { withDataContext, withLanguageContext } from '@/context';

//* Styles
import NavigationBuildingHeroStyle from './style';

//* Component
import Text from '@/components/common/Text';

const NavigationBuildingHero = ({ nameActive, globalData, selectedLang }) => {
	//! Router
	const router = useRouter();

	function clickToApartment(slug) {
		router.push(`/${selectedLang}/buildings/${slug}`);
	}

	const navigationBar = useMemo(() => {
		if (globalData) {
			const dataBuilding = [...globalData[selectedLang].buildings];
			dataBuilding.unshift({ name: 'A' });

			return dataBuilding.map((item, i) => {
				return (
					<div
						className={`building-navigation-wrapper-item ${nameActive == item.name ? 'active' : !item.slug ? 'disable' : 'hovered'}`}
						onClick={() => {
							nameActive != item.name && item.slug ? clickToApartment(item.slug) : null;
						}}
						key={i}>
						<Text className={'building-navigation-text font-montserrat-medium h5'}>{item.name}</Text>
					</div>
				);
			});
		}
	}, [globalData]);

	return <NavigationBuildingHeroStyle>{navigationBar}</NavigationBuildingHeroStyle>;
};

export default withLanguageContext(withDataContext(NavigationBuildingHero, ['globalData']), ['selectedLang']);
